<div class="table-row table-row-base">
	<div>
		{{((row().date | date: 'HH:mm') || 'No Date').padEnd(hideIcon() ? 6 : 5, '&nbsp;')}}
	</div>
	@if (!hideIcon()) {
		<div class="row-icon">
			<i class="fa-sharp fal" [ngClass]="'fa-'+rowIcon"></i>
		</div>
	}
</div>